import React, { useState, useEffect } from 'react';

const THINKING_WORDS = ['Musing', 'Ruminating', 'Imbibing', 'Feeling', 'Transcending'];

export const ThinkingIndicator: React.FC = () => {
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setWordIndex((prev) => (prev + 1) % THINKING_WORDS.length);
    }, 1500); // Rotate every 1.5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-start gap-2 mb-4 max-w-full">
      <img
        src="/assets/images/profile_picture.jpg"
        alt="Kapil Gupta"
        className="w-10 h-10 rounded-full border-2 border-primary flex-shrink-0"
      />
      <div className="flex items-center space-x-2 p-4 bg-dark-lighter rounded-lg max-w-xs shrink">
        <div className="flex space-x-1">
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <span className="text-sm text-gray-400">{THINKING_WORDS[wordIndex]}...</span>
      </div>
    </div>
  );
};
